module.exports = __webpack_public_path__ + "static/media/Youtube.9bac576c.svg";